import React, { useState } from 'react'
import Button from '@mui/material/Button';
import { delet } from '../MaterialUI';
import { Box, Modal, } from '@mui/material';
import { CrossIcon, } from '../svg';
import messageStyle from '../container/studentDashboard/messages.module.css'
import api from '../container/helper/Api';
import Toastify from '../container/helper/Toastify';
import { useNavigate } from 'react-router-dom';

const DeleteAccountAffiliate = ({
    closeModal,
    open,
    data
}) => {
    const navigate = useNavigate()
    const styles = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "white",
        border: "none",
        // padding: "27px 22px",
        height: "fit-content",
        display: "block",
        width: '70%',
        borderRadius: '7px',
        "&:focus": {
            outline: "none",
        },
    };
    const deleteAccount = async () => {
        try {
            const { data, status } = await api.deleteAffiliateAccount()

            if (status === 200) {
                Toastify.success("Account Deleted Successfully")
                navigate('/')
            } else {
                Toastify.error(data.message)
            }

        } catch (error) {
            console.log("error uploading details", error)
            Toastify.error(error.response.data.message || `something went wrong`)
        }
    }
    return (
        <Modal
            open={open}
            onClose={closeModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={styles}>
                <div className={messageStyle.basicInfo}>
                    <div className={messageStyle.notifText} style={{ color: '#F93333' }}>
                        Delete Account
                    </div>
                    <div onClick={closeModal} style={{cursor: "pointer"}}>
                        <CrossIcon />
                    </div>
                </div>
                <div style={{ margin: 20 }} className={messageStyle.deleteStyle}>
                    Are you sure you want to delete your account?
                </div>
                <div style={{ margin: 20, }} className={messageStyle.warningText}>
                    Warning: <span>If you close your account, you will be unsubscribed from all 1 of your courses and will lose access to your account and data associated with your account forever, even if you choose to create a new account using the same email address in the future.</span>
                </div>

                <div className={messageStyle.bottomButtons}>
                    <div onClick={closeModal} className={messageStyle.cancelStyle} style={{ cursor: "pointer" }}>Cancel</div>
                    <Button sx={delet} onClick={deleteAccount} variant="contained">Delete</Button>
                </div>
            </Box>
        </Modal>
    )
}

export default DeleteAccountAffiliate;